import React, { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GlobalSettingsProvider } from "./context/GlobalSettingsContext";

import AppRoutes from "./routes/AppRoutes";
import { ThemeProviderWrapper } from "./context/ThemeContext";
import { Provider } from "react-redux";
import { store } from "./shared/store/store";
import Toast from "./pages/components/toast/Toast";
import AOS from "aos";
import "aos/dist/aos.css";
import ErrorBoundary from "./shared/components/ErrorBoundary";

const App = () => {
  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: false,
      mirror: true,
    });
  }, []);

  // Language change detection and reload logic
  useEffect(() => {
    // Initialize language in localStorage if not present
    if (!localStorage.getItem("language")) {
      localStorage.setItem("language", "en");
    }

    let currentLanguage = localStorage.getItem("language") || "en";

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "language" && e.newValue !== currentLanguage) {
        currentLanguage = e.newValue || "en";
        // Reload the page when language changes
        window.location.reload();
      }
    };

    // Listen for storage events (when localStorage changes in other tabs/windows)
    window.addEventListener("storage", handleStorageChange);

    // Also listen for custom events (when language changes in the same tab)
    const handleLanguageChange = (e: CustomEvent) => {
      if (e.detail?.language !== currentLanguage) {
        currentLanguage = e.detail?.language || "en";
        // Reload the page when language changes
        window.location.reload();
      }
    };

    window.addEventListener(
      "languageChange",
      handleLanguageChange as EventListener
    );

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(
        "languageChange",
        handleLanguageChange as EventListener
      );
    };
  }, []);

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <GlobalSettingsProvider>
          {/* <ThemeProviderWrapper> */}
          <AppRoutes />
          <Toast />
          {/* </ThemeProviderWrapper> */}
        </GlobalSettingsProvider>
      </Provider>
    </ErrorBoundary>
  );
};

export default App;
